export default __webpack_public_path__ + "static/media/stroke1_filled-min.ff5ecaeb.png";